export const baseUrl = "https://localhost:5443/";



// WEBPACK FOOTER //
// ./src/shared/baseUrl.js